export interface Achievement {
    id: string;
    title: string;
    description: string;
    icon: string; // Emoji for now
    condition: {
        type: 'kill_count' | 'explore' | 'collect' | 'distance';
        targetId?: string; // 'enemy', 'Gold Coin', 'house_personal_projects', etc.
        count: number;
    };
}

export const achievements: Achievement[] = [
    {
        id: 'first_blood',
        title: 'First Blood',
        description: 'Defeat your first enemy.',
        icon: '⚔️',
        condition: { type: 'kill_count', count: 1 }
    },
    {
        id: 'gladiator',
        title: 'Gladiator',
        description: 'Defeat 10 enemies in the Arena.',
        icon: '🏟️',
        condition: { type: 'kill_count', count: 10 }
    },
    {
        id: 'collector',
        title: 'Treasure Hunter',
        description: 'Find 5 Gold Coins.',
        icon: '💰',
        condition: { type: 'collect', targetId: 'Gold Coin', count: 5 }
    },
    {
        id: 'marathon',
        title: 'Marathon Runner',
        description: 'Travel 1000 meters.',
        icon: '🏃',
        condition: { type: 'distance', count: 1000 }
    },
    {
        id: 'explorer_personal_projects',
        title: 'Project Explorer',
        description: 'Visit the Personal Projects house.',
        icon: '🏠',
        condition: { type: 'explore', targetId: 'house_personal_projects', count: 1 }
    }
];
